import getFormWizard from './getFormWizard';
import getPanelById from './getPanelById';
import getStep from './getStep';

/**
 * Gets the next step attached to the next button or its panel
 *
 * @param {Element} nextButton
 */
export default function getNextStep(nextButton) {
  if (!nextButton) return;
  const formWizard = getFormWizard(nextButton);

  let nextPanelId = nextButton.dataset.target;
  if (nextPanelId) return getPanelById(formWizard, nextPanelId);

  // if no target on the next button, look if there's a target set on the panel
  const currentPanel = getStep(nextButton);
  nextPanelId = currentPanel.dataset.target;
  if (nextPanelId) return getPanelById(formWizard, nextPanelId);
}
